<template>
  <div
    class="divide-static-default-mid flex flex-col space-y-8 divide-y *:py-12"
  >
    <BaseOrderlineBlock
      v-for="orderLine in order.orderLines"
      :key="orderLine.id"
    >
      <div class="caption">
        {{ i18n(translations.totalPriceWithTaxs) }}
      </div>
      <div class="body-2-bold mb-8">
        {{ i18n.price(orderLine.priceWithTaxes) }}
      </div>

      <div v-if="orderLine.refunded" class="text-static-info-hi body-2-bold">
        <template
          v-if="orderLine.refunded.amount === orderLine.priceWithTaxes.amount"
        >
          {{ i18n(translations.fullRefund) }}
        </template>
        <template
          v-if="orderLine.refunded.amount !== orderLine.priceWithTaxes.amount"
        >
          {{
            i18n(translations.refundedPrice, {
              price: i18n.price(orderLine.refunded),
            })
          }}
        </template>
      </div>

      <div class="mt-8 flex items-center">
        <RevIllustration
          v-if="paymentMethodIcon(order.paymentMethod.bmCode)"
          :alt="`payment-${order.paymentMethod.bmCode}`"
          class="mr-8"
          :height="36"
          :src="paymentMethodIcon(order.paymentMethod.bmCode)!"
          :width="36"
        />

        <div class="flex flex-col">
          <span>{{ order.paymentMethod.name }}</span>
          <span v-if="timeBeforeExpirationLabel" class="caption">
            {{ timeBeforeExpirationLabel }}
          </span>
        </div>
      </div>
      <RevLink class="text-left" @click="handleOpenFinancialDetails">
        {{ i18n(translations.seeFinancialDetails) }}
      </RevLink>
    </BaseOrderlineBlock>
  </div>
</template>

<script setup lang="ts">
import { computed } from 'vue'

import { paymentMethodIcon } from '@backmarket/nuxt-layer-payment/methods'
import { useI18n } from '@backmarket/nuxt-module-i18n/useI18n'
import { RevIllustration } from '@ds/components/Illustration'
import { RevLink } from '@ds/components/Link'

import type { Order } from '../../../../Tab.types'
import { useOrderRecapDrawer } from '../../composables/useOrderRecapDrawer'
import BaseOrderlineBlock from '../BaseOrderlineBlock/BaseOrderlineBlock.vue'

import translations from './PaymentsCell.translations'

const i18n = useI18n()
const { openFinancialDetails } = useOrderRecapDrawer()

const props = defineProps<{ order: Order }>()

const timeBeforeExpirationLabel = computed(() => {
  if (
    !props.order.paymentMethod ||
    !props.order.paymentMethod.timeBeforeExpiration
  )
    return null

  return props.order.paymentMethod.timeBeforeExpiration < 60
    ? i18n(translations.timeBeforeExpirationInMinutes, {
        time: props.order.paymentMethod.timeBeforeExpiration,
      })
    : i18n(translations.timeBeforeExpirationInHours, {
        time: Math.round(props.order.paymentMethod.timeBeforeExpiration / 60),
      })
})

async function handleOpenFinancialDetails() {
  await openFinancialDetails(props.order.id)
}
</script>
